import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from 'app/services/apis.service';

@Component({
  selector: 'app-service-detailss',
  templateUrl: './service-detailss.component.html',
  styleUrls: ['./service-detailss.component.scss']
})
export class ServiceDetailssComponent implements OnInit {
  public userId :any
  public services : any

  constructor(
    private activatedRoute: ActivatedRoute , 
    private apiService : ApisService,
    private router: Router
  ) { }
  ngOnInit(): void {
    // this.activatedRoute.params.subscribe(params => {
    //   this.userId= params['id'];
    // })
    this.userId = 19363;  // 👈 Hardcoded ID

    this.getServices()
  }

  getServices() { 
    this.apiService.serviceByUserId(this.userId).subscribe({
      next: (response: any) => {
        this.services = response.data?.items
        console.log("response" , response);
      }, 
      error(err) {
        console.log("error in fetching data", err);
      },
    })
  }
}
